import React from 'react';
import {connect} from "react-redux";
import GlobalErrorContainer from "./GlobalErrorContainer";

class AppWithGlobalErrorHandling  extends React.Component {

    render() {
        if(this.props.errorType)
            return <GlobalErrorContainer/>;
        else
            return this.props.children;
    }

}

export default connect(
    (state) => {
        return {
            errorType: state.errors.errorType
        }
    }
)(AppWithGlobalErrorHandling )
